export default __webpack_public_path__ + "static/media/Trondheim kommunevåpen.32ada2c5.svg";